import api from '@/api';
import { API_BASE_URL } from '..';
import {
  GenerateWorkOrderVehicleHistoryRequest,
  GenereteWorkOrderByInvoiceRequest,
  ReportWorkOrderPaymentReceipt,
} from './workOrderReport.types';

const URL = `${API_BASE_URL}/generate/work-order`;

export const workOrderReportServices = {
  async byInvoice(params: GenereteWorkOrderByInvoiceRequest) {
    const result = (await api.getReport(
      `${URL}/by-invoice`,
      params,
    )) as unknown;

    return result as BlobPart;
  },

  async vehicleHistory(params: GenerateWorkOrderVehicleHistoryRequest) {
    const result = (await api.getReport(
      `${URL}/vehicle-history`,
      params,
    )) as unknown;

    return result as BlobPart;
  },

  async paymentReceipt(params: ReportWorkOrderPaymentReceipt) {
    const response = (await api.getReport(
      `${URL}/${params.workOrderId}/payment-receipt`,
      params,
    )) as unknown;

    return response as BlobPart;
  },
};
